export class WebTrendsObject {

    public email: string;
    public city: string;
    public isp: string;
    public vas: string;
    public full_name: string;
    public bussines_name: string;
        public tpd?: string;
        public tpt?: string;
        public appid_av?: string;
        public appid?: string;
        public TI?: string;
        public channel: string;
        public action_av?: string;
        public action?: string;
        // public new_cust_ind?: string;
        // public reg_to_my?: string;
        public stage_desc?: string;
        public Token?:string;
        public stage_status?: number;
        public errorMsg?: number;
        public errormsg_desc?: string;
        public verification_mode?: string;
        public hativa_pratit?: string;
        public activity_number?: string;
        public phone_number?: string;
        public id_number?: string;
      //  public emai?: string;
        public stage_code?: string;
        public locationֹ_process?: string;
        public x_param_name?: string;
        public x_param?: string;
        public new_cust_ind: number;

        public street: string;

        public street_number: string;

        public amount: string;

        constructor(
            action?: string,
          //  stage_status?: number,
            errorMsg?: number
        ) {
            // this.appid_av = 'ISP_PASS_RESET';
            // this.appid = 'ISP_PASS_RESET';
            // this.TI = 'ISP_PASS_RESET';

            this.action = (action != null) ? action : null;
            this.action_av = (action != null) ? action : null;
            // this.new_cust_ind = (action != null) ? action : null;
            // this.reg_to_my = (action != null) ? action : null;
            //this.stage_desc = (action != null) ? action : null;

        //    this.stage_status = stage_status;
            this.errorMsg = errorMsg;
        }

        setAction(action: string) {
            this.action = (action != null) ? action : null;
            this.action_av = (action != null) ? action : null;
            // this.new_cust_ind = (action != null) ? action : null;
            // this.reg_to_my = (action != null) ? action : null;
            this.stage_desc = (action != null) ? action : null;
          //  this.verification_mode = (verification_mode != null) ? verification_mode : null;
        }

        // setVerificationMode(verification_mode: string) {
        //     this.verification_mode = verification_mode;
        // }

        setDateTime() {
            const now = new Date();
            this.tpd = (now.getDate()) + '/' + (now.getMonth() + 1) + '/' + now.getFullYear();
            this.tpt = now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds();
        }

        setErrormsgDesc(errormsg_desc?: string) {
            this.errormsg_desc = (errormsg_desc != null) ? errormsg_desc : null;
        }

        // setActivityNumber(activity_number: string) {
        //     this.activity_number = activity_number;
        // }

        setCellNumber(phone_number: string) {
            this.phone_number = phone_number;
        }

        setIDNumber(id_number: string) {
            this.id_number = id_number;
        }
        setToken(token:string){
            this.Token=token;
            }
        // setEmail(emai: string) {
        //     this.emai = emai;
        // }

        reset() {
            this.action = null;
            this.action_av = null;
            this.Token=null;
            // this.new_cust_ind = null;
            // this.reg_to_my = null;
            this.stage_desc = null;
           // this.verification_mode = null;
            this.stage_status = null;
            this.errorMsg = null;
            this.errormsg_desc = null;
           // this.activity_number = null;
            this.phone_number = null;
            this.id_number = null;
           // this.emai = null;
            this.locationֹ_process = null;
            this.x_param_name = null;
            this.x_param = null;
            this.amount = null;
        }
    }
